import type { ITheme } from '@xterm/xterm';
import { FitAddon } from '@xterm/addon-fit';
import { SearchAddon } from '@xterm/addon-search';
import { Terminal } from '@xterm/xterm';
import '@xterm/xterm/css/xterm.css';

export interface TerminalHandle {
  term: Terminal;
  search: SearchAddon;
  fit(): void;
  focus(): void;
}

export function createTerminal(
  container: HTMLElement,
  onData: (data: string) => void,
  theme: ITheme,
  fontSize: number,
  onResize?: (cols: number, rows: number) => void,
): TerminalHandle {
  const term = new Terminal({
    cursorBlink: true,
    convertEol: false,
    fontFamily: "'JetBrains Mono', 'Fira Code', 'Cascadia Code', 'DejaVu Sans Mono', monospace",
    fontSize,
    lineHeight: 1.2,
    scrollback: 5000,
    theme,
  });

  const fitAddon = new FitAddon();
  const search = new SearchAddon();
  term.loadAddon(fitAddon);
  term.loadAddon(search);
  term.open(container);
  term.onData(onData);

  const fit = (): void => {
    try {
      fitAddon.fit();
    } catch {
      /* conteneur masqué ou non mesurable */
    }
    onResize?.(term.cols, term.rows);
  };
  fit();

  const observer = new ResizeObserver(() => fit());
  observer.observe(container);
  window.addEventListener('resize', fit);

  return { term, search, fit, focus: () => term.focus() };
}
